import { useEffect } from "react";
import type { ReactNode } from "react";
import { Grid, Typography } from "@mui/material";
import { useOnlineStatus } from "providers/OnlineStatusProvider";
import WifiOffIcon from "@mui/icons-material/WifiOff";
import { useUser } from "providers/Authentication/SecuUserProvider";
import ApplicationRoles from "constants/ApplicationRoles";

function NoRowsOverlay(): ReactNode {
  const { isOnline, checkIfOnline } = useOnlineStatus();
  const { isRoles } = useUser();

  useEffect(() => {
    void checkIfOnline();
  }, [checkIfOnline]);

  if (!isOnline) {
    return (
      <Grid container sx={{ height: "100%", justifyContent: "center", alignContent: "center" }}>
        <Grid>
          <WifiOffIcon fontSize="large" />
        </Grid>
        <Grid size={12}>
          <Typography textAlign="center">Vous êtes hors ligne</Typography>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container sx={{ height: "100%", justifyContent: "center", alignContent: "center" }}>
      <Typography textAlign="center">
        {isRoles(ApplicationRoles.MODERATOR)
          ? "Aucune déclaration ne correspond à vos filtres"
          : "Vous n'avez créé aucune déclaration pour l'instant."}
      </Typography>
    </Grid>
  );
}

export default NoRowsOverlay;
